<template>
    <div class="ForgotPwd">
        <app-header :title="$t('forgotPwd.forgot_pwd')" @on-click="goBack"></app-header>
        <component :is="currentComponent" :queryObj="$route.query"></component>
    </div>
</template>

<script>
import EmailFindPwd from './components/EmailFindPwd.vue'
import PhoneFindPwd from './components/PhoneFindPwd.vue'
export default {
    name:'ForgotPwd',
    components: {
        EmailFindPwd,
        PhoneFindPwd,
    },
    data(){
        return {
            currentComponent: this.defaultComponent()
        }
    },
    methods:{
        defaultComponent:function(){
          let loginType = this.$route.query.loginType
          if(loginType === 'email'){
              return EmailFindPwd;
          }
          if(loginType === 'phone'){
              return PhoneFindPwd;
          }
        },
        goBack() {
            this.$router.go(-1);
        },
    }
}
</script>

<style lang="less" scoped>
</style>